import React from 'react';

export const LogoIcon = ({ size = 60 }) => (
  <img
    src="/aug_logo.png"
    alt="Agro Urban Global"
    width={size}
    height={size}
    style={{ width: size, height: size, objectFit: 'contain' }}
  />
);

export const LogoHorizontal = ({ iconSize = 48 }) => (
  <div className="flex items-center gap-3">
    <LogoIcon size={iconSize} />
    <span className="text-xl font-bold tracking-wide" style={{ color: "#1B5E20" }}>
      AGRO URBAN <span style={{ color: "#F9A825" }}>GLOBAL</span>
    </span>
  </div>
);

export default LogoIcon;
